import { AdvisorGroupSetting } from '@/store/settingsApi';

const AdvisorGroupSettings = (
  advisorGroupSettings: AdvisorGroupSetting[] | undefined,
) => {
  const getByKey = (
    setting: string,
    key: keyof AdvisorGroupSetting = 'Value',
  ) => {
    if (!advisorGroupSettings) {
      return;
    }

    const groupSetting = advisorGroupSettings.find((x) => x.Key === setting);

    if (!setting) {
      console.error('Could not find setting: ', setting);
    }

    const str = String(groupSetting?.[key] ?? '').toLowerCase();
    return str === 'true' || str === '1' || str === 'yes';
  };

  return {
    getByKey,
  };
};

export default AdvisorGroupSettings;
